import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { AttractionResultCardProps } from '../types/bot.types';
import { Button } from 'antd';
import { IoMap } from 'react-icons/io5';
import { formatBotPrice } from './formatBotPrice';
import { formatBotCurrency } from './formatBotCurrency';

const AttractionResultCard: React.FC<AttractionResultCardProps> = ({
  name, category, location, date, duration, price, currency, highlights, imageUrl, onSelect,
}) => {
  const t = useSelector((s: RootState) => (s.config.translations as any)?.bot);

  return (
    <div className="bot-result-card bot-result-card--attraction">
      <div className="bot-result-card__image-wrap">
        {imageUrl
          ? <img src={imageUrl} alt={name} className="bot-result-card__image" />
          : <div className="bot-result-card__image-placeholder"><IoMap size={32} /></div>}
      </div>
      <div className="bot-result-card__body">
        <div className="bot-result-card__name">{name}</div>
        {category && <span className="bot-result-card__badge">{category}</span>}
        {location && <div className="bot-result-card__meta">📍 {location}</div>}
        {date && <div className="bot-result-card__dates">📅 {date}</div>}
        {duration && <div className="bot-result-card__meta">⏱ {duration}</div>}
        {highlights && <div className="bot-result-card__highlights">{highlights.slice(0, 120)}</div>}
      </div>
      <div className="bot-result-card__footer">
        <div className="bot-result-card__price">{formatBotCurrency(currency)} {formatBotPrice(price)}</div>
        <Button size="small" type="primary" className="btn-style-5" onClick={onSelect}>
          {t?.result?.select ?? 'Select'}
        </Button>
      </div>
    </div>
  );
};

export default AttractionResultCard;
